import { memo, FC, useEffect } from "react";
import { get } from "lodash";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Placeholder from "images/system-maintenance.png";
import BackButton from "components/BackButton";
import config from "config";
import styles from "./index.module.scss";

interface ISystemMaintenance {}

const SystemMaintenance: FC<ISystemMaintenance> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const fn = async () => {
      fetch(config.API_URL + "/bot/get", { method: "POST" })
        .then((res) => res.json())
        .then((res) => {
          if (get(res, "code") === 200) {
            history.replace("/chat");
          }
        })
        .catch((e) => {
          console.log(e);
        })
    };
    fn();
  }, [dispatch, history]);

  return (
    <div className={styles.root}>
      <img src={Placeholder} alt="Placeholder" />
      <BackButton />
    </div>
  );
};

export default memo(SystemMaintenance);
